import http from './http'

const permissaoService = {
  getByProgramaUsuario: (usuario) => http.get(`/niveis/${usuario}`).then(result => result.data),
  save: item => http.post('/niveis', item).then(result => result.data)
}
export default permissaoService
